<template>
    <div class="preview-page">
        <PageBar>
            <div class="page-bar">
                <i class="el-icon-back" />
                <span class="colse" v-matomo="{ behaviorCategory: '荣耀(批量搭建)', name: '生成预览(取消)' }"
                    @click="handleCancel">取消</span>
                |
                <span class="add">批量创建</span>
                <el-button><span class="prev" v-matomo="{ behaviorCategory: '荣耀(批量搭建)', name: '生成预览(上一步)' }"
                        @click="handleBack">上一步</span></el-button>
                <el-button type="primary" :loading="saveloading" @click="handleSave"
                    v-matomo="{ behaviorCategory: '荣耀(批量搭建)', name: '提交创建' }"><span
                        class="save">提交创建</span></el-button>
            </div>
        </PageBar>
        <div class="pt10 pb10 pl20 pr20 bg-color mt10 mb10">
            <p class="text-bold">目标账户与产品：</p>
            <p>
                <span class="text-bold"> 账户：</span>
                {{ account_info?.[0]?.account_name }}（ID：{{ account_info?.[0]?.account_id }}）；
                <span class="text-bold"> 产品：</span> {{app_info.map(item => item.app_name + '(' + item.app_id +
                ')').join('、')}}
            </p>
            <div class="tool-bar mt10">
            <el-button type="primary"  plain size="mini" @click="batchChangeAdName" :loading="batchAdNameLoading" :disabled="selectionRow.length<=0">
                广告应用素材名称
                <el-tooltip class="item" effect="dark" placement="top">
                    <i class="el-icon-question"></i>
                    <div slot="content">
                        <p>按照以下优先级取素材名称应用至广告名称：<br/>视频素材 > 图片素材 > 图标素材</p>
                    </div>
                </el-tooltip>
            </el-button>
         </div>
        </div>
         
        <div class="preview-content mt10 bg-color">
            <jt-table :data="tableData" style="width: 100%;margin-top: 10px;" stripe
                :header-cell-style="{ background: '#e8eaec', color: '#333' }" :row-class-name="tableRowClassName"
                size="mini" row-key="id" class="create_vivo_list" v-loading="loading"
                @selection-change="selectionChange"
                :affixConfig="{ offset: { top: 96, bottom: 0 } }" tooltip-effect="dark">
                <el-table-column
                    type="selection"
                    :selectable="(row,index)=>index!==0"
                    width="55">
                </el-table-column>
                <el-table-column label="序号" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">总计</span>
                        <span v-else>{{ ((currentPage - 1) * pageSize) + scope.$index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="产品信息" min-width="200" show-overflow-tooltip prop="apps">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{ row.apps.product_name || '-' }}</p>
                            <p>ID: {{ row.apps.promotion_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="版位" min-width="200" show-overflow-tooltip prop="creative_size_name">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{ row.adgroup_info.ad_placement_name || '-' }}</p>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column label="计划信息" min-width="200">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">{{ row.plan_total }}</span>
                        <template v-else>
                              <p>计划状态：{{ row.campaign_info.plan_status_text }}</p>
                              <p>计划ID: {{  row.campaign_info.campaign_id }} </p>
                              <p>计划名称: {{  row.campaign_info.campaign_name }} </p>
                              <p>推广目标: {{  row.campaign_info.promotion_purpose_text }} </p>
                              <p>当日预算: {{  row.campaign_info.ad_day_budget }} </p>
                              <p>次日生效预算: {{  row.campaign_info.ad_next_day_budget }} </p>
                              <p>流量场景：{{row.adgroup_info.traffic_type_text}}</p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="任务信息" min-width="300">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">{{ scope.row.adgroup_total }}</span>
                        <div v-else>
                            <p>任务状态：{{scope.row.adgroup_info.ad_group_status_text}}</p>
                            <p>广告组ID：{{scope.row.adgroup_info.adgroup_id}}</p>
                            <p>广告组名称：{{scope.row.adgroup_info.adgroup_name}}</p>
                            <p>账户ID：{{scope.row.adgroup_info.account_id}}</p>
                            <p>版位ID：{{scope.row.adgroup_info.ad_placement_id}}</p>
                            <p>版位名称：{{scope.row.adgroup_info.ad_placement_name}}</p>
                            <p>应用包名：{{ scope.row.adgroup_info.package_name }}</p>
                            <el-tooltip class="item" effect="dark" placement="top">
                                <div slot="content" style="max-height:500px; overflow:auto">
                                    <p>deeplink链接：{{ scope.row.adgroup_info.deep_link_url }}</p>
                                    <p>备用H5链接：{{ scope.row.adgroup_info.h5_url }}</p>
                                    <p>是否预装：{{ scope.row.adgroup_info.install_pkg_type_text }}</p>
                                    <p>应用包类型：{{ scope.row.adgroup_info.pkg_src_text }}</p>
                                    <p>荣耀商店appId: {{ scope.row.adgroup_info.app_id_or_name }}</p>
                                    <p>应用包渠道：{{ scope.row.adgroup_info.channel_text }}</p>
                                    <p>小程序类型：{{ scope.row.adgroup_info.mini_program_type_text }}</p>
                                    <p>展示链接：{{ scope.row.adgroup_info.impression_url }}</p>
                                    <p>点击链接：{{ scope.row.adgroup_info.click_url }}</p>
                                    <p>开始投放时间：{{ scope.row.adgroup_info.start_time }}</p>
                                    <p>结束投放时间：{{ scope.row.adgroup_info.end_time }}</p>
                                    <p>付费方式：{{ scope.row.adgroup_info.pay_type_text }}</p>
                                    <p>日预算：{{ scope.row.adgroup_info.ad_day_budget }}</p>
                                    <p>次日生效预算：{{ scope.row.adgroup_info.next_day_budget }}</p>
                                    <p>一阶段出价：{{ scope.row.adgroup_info.ad_bid }}</p>
                                    <p>二阶段出价：{{ scope.row.adgroup_info.ocpx_sbp }}</p>
                                    <p>三阶段出价：{{ scope.row.adgroup_info.ocpx_deep_price }}</p>
                                    <p>定向包ID：{{ scope.row.adgroup_info.target_pkg_id }}</p>
                                    <p>定向包名称：{{ scope.row.adgroup_info.target_pkg_name }}</p>
                                    <p>投放时间段：{{ scope.row.adgroup_info.delivery_time_slot_dtos_text }}</p>
                                    <p>转化目标：{{ scope.row.adgroup_info.conv_type_text }}</p>
                                    <p>是否为程序化广告分组：{{ scope.row.adgroup_info.programmatic_text }}</p>
                                    <p>RTA ID：{{ scope.row.adgroup_info.rta_id }}</p>
                                    <p>RTA策略名称：{{ scope.row.adgroup_info.rta_name }}</p>
                                    <p>智能分包ID：{{ scope.row.adgroup_info.itg_sct_id }}</p>
                                    <p>智能分包名称：{{ scope.row.adgroup_info.itg_sct_name }}</p>
                                    <p>三阶段转化目标：{{ scope.row.adgroup_info.ocpx_deep_type_text }}</p>
                                    <p>是否效果增强：{{ scope.row.adgroup_info.enhanced_text }}</p>
                                    <p>广告播放类型：{{ scope.row.adgroup_info.play_rate_type_text }}</p>
                                    <p>增强目标：{{ scope.row.adgroup_info.enhanced_conv_type_text }}</p>
                                    <p>广告组状态开关：{{ scope.row.adgroup_info.adgroup_status_text }}</p>
                                </div>
                                <el-button type="text">更多</el-button>
                            </el-tooltip>

                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="创意名称" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">-</span>
                        <div v-else>
                            <p>
                                创意名称：{{scope.row.creative_name}}
                                <span title="编辑" class="action-btn pointer icon iconfont icon-jt-bianji text-color-primary" @click="handleEditIdeaName(scope.row)"  ></span>
                            </p>
                            <p>创意ID：{{scope.row.creative_id}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="创意详情" min-width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.$index == 0" class="text-bold">{{ scope.row.ad_total }}</span>
                        <div v-else>
                            <p>创意状态：{{scope.row.ad_status_text}}</p>
                            <p>落地页类型：{{scope.row?.landing_page_type_text}}</p>
                            <p>落地页url：{{ scope.row.landing_page_url }}</p>
                            <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row?.element_text_list.length > 0">
                                <div slot="content" style="max-height:500px; overflow:auto">
                                    <p v-for="item in scope.row.element_text_list" :key="item.id">
                                        {{ item.element_type_text }}：{{ item.title_name || '-' }}
                                    </p>
                                </div>
                                <el-button type="text">更多</el-button>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="转化跟踪" min-width="200" show-overflow-tooltip prop="effect_tracking">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{row.adgroup_info.conv_type_text||'-'}}</p>
                            <p>ID: {{  row.adgroup_info.conv_type }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="定向包" min-width="200" show-overflow-tooltip prop="targeting_package">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{row.adgroup_info.target_pkg_name||'-'}}</p>
                            <p>ID: {{  row.adgroup_info.target_pkg_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="智能分包" min-width="200" show-overflow-tooltip prop="channel">
                    <template slot-scope="{ row , $index}">
                        <span v-if="$index == 0">-</span>
                        <template v-else>
                            <p>{{row.adgroup_info.itg_sct_name||'-'}}</p>
                            <p>智能分包ID: {{  row.adgroup_info.itg_sct_id }} </p>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="创意" min-width="300" prop="material_list">
                    <template slot-scope="{ row , $index}">
                    <span v-if="$index==0">{{row.ad_num}} / {{row.ad_err_num}}</span>
                    <template v-else>
                      <IdeaColumnTemp  :list="Array.from({ length: row.material_list.length> 3 ? 3 :row.material_list.length }).map((_,i)=>row.material_list[i])"/>
                      <el-button type="text"  v-if="row.material_list.length> 3" @click="openPreviewMaterialModal(row.material_list)">点击查看更多</el-button>
                    </template>
                </template>
                </el-table-column>
            </jt-table>

            <div class="bg-color tar p20">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import PageBar from '@/components/PageBar/index.vue'
import { getBatchPreviewListApi, getBatchPreviewInfoApi, postBatchHonorSavaApi, postMaterialNameToAdNameApi, postModifyAdInfoApi } from '@/api'
import IdeaColumnTemp from '@/views/marketingManagement/configuration/page/components/ideaColumnTemp';
import { previewMaterialModal } from '@/views/marketingManagement/configuration/page/modal/index'
import { ideaSettingModal } from '../modal/index'
export default {
    name: 'PreviewPage',
    components: {
        PageBar, IdeaColumnTemp
    },
    props: {
        pageParams: {
            type: Object,
            default: () => {
                return {};
            },
        },
        platId: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            total: 10,
            tableData: [],
            loading: false,
            saveloading: false,
            account_info: {},
            app_info: [],
            selectionRow: [],
            batchAdNameLoading: false
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleEditIdeaName(row) {
            const onSubmit = async (data) => {
                const params ={
                    type: 'ad_name',
                    detail_id:row.detail_info.id,
                    data: data.text
                };
                try {
                    await postModifyAdInfoApi(params)
                    this.getTableData()
                    vm.close()
                } catch (error) {
                    this.$message.error(error.info);
                }
            }
            const { vm } = ideaSettingModal({
                props: {
                    text: row.creative_name,
                },
                cbs: {
                    onSubmit
                }
            })
        },
        openPreviewMaterialModal(list) {
            previewMaterialModal({
                props: { list },
            })
        },
        selectionChange(val){
            this.selectionRow = val;
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getTableData();
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.getTableData();
        },
        async getTableData() {
            this.loading = true;
            try {
                const [listRes, infoRes] = await Promise.all([getBatchPreviewListApi({ plat_id: this.platId, task_id: this.pageParams.id, pn: this.currentPage, rn: this.pageSize }), getBatchPreviewInfoApi({ plat_id: this.platId, task_id: this.pageParams.id })])
                this.tableData = [...infoRes.data.total_info, ...listRes.data.list]
                this.total = listRes.data.totalCnt
                this.account_info = infoRes.data.account_info || {};
                this.app_info = infoRes.data.app_info || [];
            } catch (error) {
                this.$message.error(error.info);
            } finally {
                this.loading = false;
            }
        },
        handleSave() {
            this.saveloading = true;
            postBatchHonorSavaApi({
                task_id: this.pageParams.id,
                plat_id: this.platId
            }).then(res => {
                this.$message.success(res.info);
                window.localStorage.removeItem('honor_batch')
                this.$emit("to-page", "ListPage", true)
            }).catch(err => {
                this.$message.error(err.info);
            }).finally(() => {
                this.saveloading = false;
            })
        },
        handleBack() {
            this.$emit('to-page', 'ConfigPage')
        },
        handleCancel() {
            window.localStorage.removeItem('honor_batch')
            this.$emit('to-page', 'ListPage')
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 0) {
                return 'gray-row';
            }
            return '';
        },
        batchChangeAdName(){
            this.batchAdNameLoading = true;
            postMaterialNameToAdNameApi({
                detail_ids:this.selectionRow.map(item=>item.detail_info.id),
            }).then(res=>{
                this.batchAdNameLoading = false;
                this.$message.success(res.info||'请求成功');
                this.getTableData();
            },err=>{
                this.batchAdNameLoading = false;
                this.$message.error(err.info||'请求异常');
                this.getTableData();
            });
        },
    }
}   
</script>
<style lang="scss" scoped>
.preview-page {
    padding-top: 40px;

    // background-color: #fff;
    .bg-color {
        background-color: #fff;
    }

    .page-bar {
        background: #fff;
        height: 44px;
        border-radius: 6px;
        border-bottom: 1px solid #e2e2e2;
        line-height: 44px;
        font-size: 14px;

        .colse {
            margin-right: 6px;
            cursor: pointer;
        }

        .add {
            font-weight: bold;
            margin-left: 6px;
            margin-right: 30px;
        }
    }
}
</style>